import sanitize from "sanitize-html";

export function normalizeRichText(content: unknown): string {
  if (typeof content === "string") return content;
  if (content && typeof content === "object") {
    const value = content as Record<string, unknown>;
    const text = value.html ?? value.text ?? value.content;
    if (typeof text === "string") return text;
  }
  return "";
}
export function sanitizeRichText(content: unknown): string {
  return sanitize(normalizeRichText(content), {
    allowedTags: ["p", "br", "strong", "em", "u", "s", "ul", "ol", "li", "a", "span", "div", "h2", "h3", "h4", "h5", "h6", "blockquote", "code", "pre", "table", "thead", "tbody", "tr", "th", "td"],
    allowedAttributes: { a: ["href", "title"], th: ["colspan", "rowspan"], td: ["colspan", "rowspan"] },
    allowedSchemes: ["https", "http", "mailto", "tel"],
    allowProtocolRelative: false,
  });
}
export function plainText(content: unknown) {
  return sanitize(normalizeRichText(content), { allowedTags: [], allowedAttributes: {} }).replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").trim();
}
export function contentSlug(value: string) {
  return value.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+|-+$/g, "");
}
export function portfolioSlug(item: { slug?: string | null; title?: string | null; id?: string | null }) {
  return item.slug || contentSlug(item.title || item.id || "");
}
